import moment from 'moment';
import { vacationRequestTableColumns } from '../../constants/tableColumns';
import useVacationRequestActions from '../../hooks/APIHooks/users/useVacationRequestActions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';
import CreateVacationRequestAction from './CreateVacationRequestAction';

const ShowAllVacationRequests = () => {
  // integration of custom API hooks here
  const { getVacationRequestListHandler } = useVacationRequestActions(
    'vacationRequestList'
  );

  console.log(
    'VACATION REQUEST LIST: ',
    getVacationRequestListHandler.data?.data
  );

  // rendering show all vacation requests section component here
  return (
    <>
      {getVacationRequestListHandler.isLoading ? (
        <AcademiaLoading />
      ) : getVacationRequestListHandler.isSuccess ? (
        <section>
          <PageHeader headerText='Vacation requests' />

          <AcademiaTable
            data={getVacationRequestListHandler.data.data.map((vacation) => ({
              ...vacation,
              start_date: moment(vacation.start_date).format('DD-MM-YYYY'),
              end_date: moment(vacation.end_date).format('DD-MM-YYYY'),
              status: vacation.is_approved
                ? 'Approved'
                : vacation.is_rejected
                ? 'Rejected'
                : 'Pending',
            }))}
            columns={vacationRequestTableColumns}
            notFoundMessage='No vacation request found!'
            tableToolbarComponent={<CreateVacationRequestAction />}
          />
        </section>
      ) : getVacationRequestListHandler.isError ? (
        <AcademiaNotFound message='Failed to load vacation data!!' />
      ) : null}
    </>
  );
};

export default ShowAllVacationRequests;
